import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { FirmwareResponseDto } from '../dtos/firmware-response.dto';
import { FirmwareResponseModel } from '../models/firmware-response.model';
import { mapFirmwareResponseDtoToFirmwareResponseModel } from '../utils/mapping/mapping.util';

export const getFirmwareById = createAsyncThunk<FirmwareResponseModel, number>(
  'firmware/get-firmware-by-id',
  async (firmwareId: number): Promise<FirmwareResponseModel> => {
    const mandantId = localStorageService.get(
      LocalStorageProperties.SELECTED_MANDANT
    ) as string | null;

    const url = createPathParams<'firmwareId' | 'mandantId'>(
      Endpoints.FIRMWARE_BY_ID,
      {
        ...(mandantId !== null && { mandantId: parseInt(mandantId, 10) }),
        firmwareId,
      }
    );

    const { data }: AxiosResponse<FirmwareResponseDto> =
      await axiosInstance.get(url);

    return mapFirmwareResponseDtoToFirmwareResponseModel(data);
  }
);
